import React, { PureComponent } from 'react';
import _filter from 'lodash/filter';

class AccommodationView extends PureComponent {

  constructor(props){
    super(props);
    this.state = {
      moreClicked:false
    }
    this.moreClicked = this.moreClicked.bind(this);
  }

  moreClicked(){
    this.setState({moreClicked: !this.state.moreClicked});
  }

  hostelDetails(props){

    const activeSectors = _filter(props.sectors, ['name', props.active]);
    const _hostelName = _filter(props.cities, ["ctfl_id", activeSectors[0].city_ctfl_id]);
   
    return {
      "hw_name":(_hostelName.length > 0 && _hostelName[0].hostels.length > 0) ? _hostelName[0].hostels[0].hw_name : "",
      "hw_rating": (_hostelName.length > 0 && _hostelName[0].hostels.length > 0)? _hostelName[0].hostels[0].hw_rating : "",
      "hw_facilities": (_hostelName.length > 0 && _hostelName[0].hostels.length > 0) ? _hostelName[0].hostels[0].hw_facilities : "",
      "hw_description_short": (_hostelName.length > 0 && _hostelName[0].hostels.length > 0) ? (_hostelName[0].hostels[0].hw_description !== null && _hostelName[0].hostels[0].hw_description.length > 400) ? _hostelName[0].hostels[0].hw_description.substring(0, 400) : _hostelName[0].hostels[0].hw_description : "",
      "hw_description": (_hostelName.length > 0 && _hostelName[0].hostels.length > 0) ? _hostelName[0].hostels[0].hw_description : "",
      "hw_image_url": (_hostelName.length > 0 && _hostelName[0].hostels.length > 0) ? _hostelName[0].hostels[0].hw_image_url : "",
    }
  }

  render(){

    const { sectors, active } = this.props;
    const { moreClicked } = this.state;

    const activeSectors = _filter(sectors, ['name', active]);

    return (
      <div className="accommodation-view" style={{display: this.hostelDetails(this.props).hw_name === "" ? "none" : "block"}}>
        <div className="row">
          <div className="column small-12 medium-6">
            <p className="no-margin grey-subtile-text">{activeSectors[0].city} Recommended Accommodation</p>
            <h5 className="busabout-h5 margin-b-20">{this.hostelDetails(this.props).hw_name}</h5>
            <p className="rating-text">We recommend you stay with {this.hostelDetails(this.props).hw_name}. Rated <span className="green-text bold">{this.hostelDetails(this.props).hw_rating}%</span> on HostelWorld.</p>

            <p className="bold margin-t-30">
              <span className="ba-icon ba_icon_map_location"></span>
              Location in {activeSectors[0].city}
            </p>
            <p className="margin-b-20">
              { !moreClicked ? this.hostelDetails(this.props).hw_description_short : this.hostelDetails(this.props).hw_description }
              <span className="orange-text more-text" onClick={this.moreClicked} style={{display: moreClicked ? 'none' : 'inline' }}> more...</span>
            </p>


            <p className="bold">
              <span className="ba-icon ba-icon-atmosphere-alt"></span>
              Facilities and service
            </p>
            <p>{this.hostelDetails(this.props).hw_facilities}</p>
          </div>

          <div className="column small-12 medium-6">
            <div className="accommodation-view-image">
              <img alt="Hostel Accommodation" src={`${this.hostelDetails(this.props).hw_image_url}`} />
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default AccommodationView;



// WEBPACK FOOTER //
// ./src/components/itinerary/city/components/accomodation-view.js